/* eslint-disable */

import auth from "./Auth";
import srsCodes from "./SrsCodes";
import stockItems from "./StockItems"
import superSuppliers from "./SuperSuppliers";
import suppliers from './Suppliers.api';
import roles from "./Roles";
import corpUsers from "./CorpUsers";
import vipSales from "./VipSale.api";
import users from "./users.api.js";

export default {
    auth,
    srsCodes,
    stockItems,
    superSuppliers,
    suppliers,
    roles,
    corpUsers,
    vipSales,
    users,
};
